// extracted by mini-css-extract-plugin
export default {"component":"CheckboxComponent_component__Rulu2"};